/**
 * Resolve the API origin for production builds.
 *
 * REACT_APP_API_URL is baked in at build time (prod: https://gotrutax.com) while most visitors
 * browse https://www.gotrutax.com. Calling the apex from www makes every authenticated request
 * cross-origin (extra CORS preflight per call, and requests the browser cancels on navigation
 * surface as net::ERR_FAILED). When the configured host is only the www/apex variant of the page's
 * host, use the page's own origin so API calls stay same-origin. Auth is bearer-token based, so no
 * cookies depend on the host.
 */
export const resolveApiOrigin = (envValue: string | undefined, fallback = ''): string => {
  const env = envValue?.trim();
  if (typeof window === 'undefined' || !window.location?.origin) return env || fallback;
  if (!env) return window.location.origin;
  try {
    const u = new URL(env);
    const strip = (h: string) => h.replace(/^www\./i, '').toLowerCase();
    if (strip(u.hostname) === strip(window.location.hostname) && u.hostname !== window.location.hostname) {
      return window.location.origin + u.pathname.replace(/\/$/, '');
    }
  } catch {
    /* relative or malformed: keep as configured */
  }
  return env;
};
